import { ReduxService } from 'dashboard-services/services';

import { taskInspectorDataScienceActions } from 'actions/modules/datascience';

export const inspectorInitialState = {
  allTasks: false,
  groupName: "",
  open: false,
  taskId: undefined,
  taskName: ""
}
export default (state = inspectorInitialState, action) => {
  switch (action.type) {
    case taskInspectorDataScienceActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}